<div class="integration-status-item" *ngIf="integration">
    <div class="integration-status-item-body">
        <div class="integration-status-item-icon"><img [src]="getLogo(integration) | safe" /></div>
        <div class="integration-status-item-name">{{ integration.friendly_name }}</div>
        <div class="integration-status-item-status" [nbTooltip]="integration.status_message">
            <div class="integration-status-item-status-icon">
                <i class="fa-solid fa-circle"
                    [ngClass]="{'active': integration.status === 'ok', 'inactive': (integration.status !== 'ok' && integration.status !== 'failed'), 'error' : integration.status === 'failed'}"></i>
            </div>
            <div class="integration-status-item-status-text">
                <strong>{{'status'| translation}}: </strong>
                <span *ngIf="integration.status === 'ok'">{{'online'| translation}}</span>
                <span *ngIf="integration.status !== 'ok' && integration.status !== 'failed'">{{'inactive'|
                    translation}}</span>
                <span *ngIf="integration.status === 'failed'">{{'error'| translation}}</span>
            </div>
        </div>
    </div>
    <div class="integration-status-item-footer">
        <div class="integration-status-item-type" [style]='getTypeColor(integration) | safeStyle'>{{
            integration.integration_type | transformText : 'uppercase' }}</div>
        <div class="integration-status-item-integration-type">{{ (integration.lms_type || integration.sis_type) |
            transformText : 'capitalize' }} Integration</div>
        <div class="integration-status-item-updated-at">{{'updated'| translation | transformText : 'capitalize' }}: {{
            integration.updated_at | date: 'dd/mm/yyyy hh:mma' }}</div>
    </div>
</div>